import React from 'react';
import { FormBuilder } from 'commons-ui';
import useCreate from '../../create/useCreate';
import {
	LAUNCH_WIDGET_FORM_FIELD_CONFIG,
	FORM_LAYOUT_CONFIG,
	getLaunchWidgetFormDefaults,
	launchWidgetValidationSchema
} from '../utils/formConfig';

const CreateLaunchWidget: React.FC<{}> = () => {
	const { showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useCreate();
	const defaultFormData = getLaunchWidgetFormDefaults();

	return (
		<FormBuilder
			data={defaultFormData}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={launchWidgetValidationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={LAUNCH_WIDGET_FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
			dependencies={[]}
		/>
	);
};

export default CreateLaunchWidget;
